import { Reveal, Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { CTAButton } from "../common/CTAButton";
import { constructionGroups, constructionWorkforce, images } from "../../data/content";
import { CheckCircle } from "@phosphor-icons/react";

export const ConstructionSection = ({ full = false }) => (
    <section className="relative bg-white grain" data-testid="construction-section">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <Reveal>
                    <div className="relative">
                        <img src={images.construction} alt="FRONTX construction and project execution" className="w-full h-[300px] lg:h-[440px] object-cover rounded-sm" />
                        <div className="absolute -bottom-6 -left-4 lg:-left-8 bg-brand text-white p-6 rounded-sm max-w-[260px] shadow-xl">
                            <div className="font-display font-bold text-lg leading-tight">From Workforce to Project Execution</div>
                            <div className="mt-1 text-sm text-blue-100">One Integrated Partner</div>
                        </div>
                    </div>
                </Reveal>
                <div>
                    <SectionHeading
                        overline="Construction Services"
                        title="Construction & Project Execution Services"
                        subtitle="FRONTX provides construction and allied project services along with manpower solutions — enabling you to plan, build and manage with a single partner."
                    />
                    <div className="mt-8">
                        <CTAButton to="/contact#construction" variant="primary" data-testid="construction-cta">Discuss Your Construction Project</CTAButton>
                    </div>
                </div>
            </div>

            <Stagger className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {constructionGroups.map((g) => (
                    <StaggerItem key={g.title}>
                        <div className="h-full p-7 rounded-sm border border-slate-200 bg-[#f8fafc] hover:border-brand hover:-translate-y-1 transition-all duration-300">
                            <g.icon size={34} weight="duotone" className="text-brand" />
                            <h3 className="mt-5 font-display font-bold text-lg text-navy tracking-tight">{g.title}</h3>
                            <ul className="mt-4 space-y-2">
                                {g.items.map((it) => (
                                    <li key={it} className="flex items-start gap-2 text-sm text-slate-600">
                                        <CheckCircle size={16} weight="fill" className="text-brand mt-0.5 shrink-0" />
                                        {it}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </StaggerItem>
                ))}
            </Stagger>

            {full && (
                <div className="mt-16 rounded-sm bg-navy text-white p-8 lg:p-12 grain relative overflow-hidden">
                    <div className="relative z-10">
                        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">Construction Workforce</div>
                        <h3 className="mt-3 font-display font-bold text-2xl lg:text-3xl">Skilled teams for every stage of construction</h3>
                        <div className="mt-6 flex flex-wrap gap-2.5">
                            {constructionWorkforce.map((w) => (
                                <span key={w} className="text-sm px-3.5 py-2 rounded-sm bg-white/5 border border-white/10 text-slate-200">{w}</span>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    </section>
);
